module.exports = __webpack_public_path__ + "img/dashiji-2017.a7196f49.jpg";